import { useLanguage } from "@/lib/i18n";
import { LegalPageLayout } from "./LegalPageLayout";
import { Truck, MapPin, Headphones } from "lucide-react";

export default function ShippingPolicyPage() {
  const { t } = useLanguage();

  return (
    <LegalPageLayout titleKey="legal.shipping.title" seoDescriptionKey="legal.shipping.seoDescription" pagePath="/shipping">
      <h1 className="text-2xl md:text-3xl font-bold mb-2">{t('legal.shipping.title')}</h1>
      <p className="text-sm text-muted-foreground mb-8">{t('legal.shipping.subtitle')}</p>

      <Section icon={<Truck className="w-5 h-5 text-primary" />} title={t('legal.shipping.delivery.title')}>
        <P>{t('legal.shipping.delivery.content')}</P>
        <P>{t('legal.shipping.delivery.times')}</P>
      </Section>

      <Section icon={<MapPin className="w-5 h-5 text-primary" />} title={t('legal.shipping.tracking.title')}>
        <P>{t('legal.shipping.tracking.content')}</P>
      </Section>

      <Section icon={<Headphones className="w-5 h-5 text-primary" />} title={t('legal.shipping.support.title')}>
        <P>{t('legal.shipping.support.content')}</P>
      </Section>
    </LegalPageLayout>
  );
}

function Section({ title, icon, children }: { title: string; icon?: React.ReactNode; children: React.ReactNode }) {
  return (
    <section className="mb-8">
      <div className="flex items-center gap-2 mb-3">
        {icon}
        <h2 className="legal-heading text-lg font-semibold">{title}</h2>
      </div>
      {children}
    </section>
  );
}

function P({ children }: { children: React.ReactNode }) {
  return <p className="legal-content text-sm text-muted-foreground leading-relaxed mb-2">{children}</p>;
}
